import { InputAdornment, TextField } from '@mui/material';
import { getFieldLabel } from '../../utils';
import { useTranslation } from 'react-i18next';
import { FormFieldProps } from '.';
import { FieldHelperText } from './FieldHelperText';

export function NumberField(props: FormFieldProps) {
  const { field, inputProps, sx } = props;
  const { t } = useTranslation();
  const { unit, description } = field.fieldAttributes ?? {};

  return (
    <>
      <TextField
        {...props}
        fullWidth
        label={getFieldLabel({ field, t })}
        type="number"
        InputProps={{
          endAdornment: unit && (
            <InputAdornment position="end">{unit}</InputAdornment>
          ),
          readOnly: inputProps?.readOnly ?? false,
        }}
        sx={{
          '& input[type=number]': {
            MozAppearance: 'textfield',
          },
          '& input[type=number]::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          '& input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          '& .MuiInputBase-root': {
            background: props.isImported
              ? theme => theme.palette.grey[200]
              : null,
          },
          ...sx,
        }}
        onScroll={(e: any) => {
          e.target.blur();
        }}
        onWheel={(e: any) => {
          e.target.blur();
        }}
        InputLabelProps={{ shrink: true }}
        helperText={
          <FieldHelperText
            description={description}
            helperText={props.helperText}
            error={props.error}
          />}
      />
    </>
  );
}
